var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeciality22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#208ce1;stroke:#208ce1;stroke-width:0.1px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-334 -7072)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(334 7072)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-344.001 -7081)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.001 12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M28.455,964.375a.583.583,0,0,0-.437.456c-1.05,5.036-4.187,9.719-7.255,14.433s-6.078,9.468-6.671,14.779a12.3,12.3,0,0,0,3.882,10.734,15.752,15.752,0,0,0,10.608,3.918,16.167,16.167,0,0,0,9.077-2.715.583.583,0,1,0-.656-.948,15.025,15.025,0,0,1-8.421,2.5,14.589,14.589,0,0,1-9.806-3.608,11.06,11.06,0,0,1-3.518-9.75c.553-4.953,3.411-9.584,6.471-14.287,2.708-4.161,5.479-8.392,6.872-13.012a33.987,33.987,0,0,0,3.08,7.053,14.592,14.592,0,1,0,14.163,25.44l2.625,2.606-1.057,1.057a.583.583,0,0,0,0,.82l4.666,4.665a.586.586,0,0,0,.838-.82l-4.247-4.246,4.994-5.012,1.331,1.33a.586.586,0,0,0,.838-.82l-1.75-1.75a.583.583,0,0,0-.838,0l-.456.456-2.625-2.624a14.58,14.58,0,0,0-17.407-21.559,29.36,29.36,0,0,1-3.609-8.638.583.583,0,0,0-.693-.456Zm9.46,9.349a13.394,13.394,0,1,1-13.4,13.394A13.374,13.374,0,0,1,37.915,973.724Zm0,2.9a10.5,10.5,0,1,0,10.5,10.5A10.507,10.507,0,0,0,37.915,976.621Zm0,1.166a9.331,9.331,0,1,1-9.333,9.331A9.323,9.323,0,0,1,37.915,977.788Zm-.055,4.647a.583.583,0,0,0-.383.219l-4.083,4.665a.583.583,0,1,0,.875.765l4.083-4.665a.583.583,0,0,0-.492-.984Zm4.666,1.166a.583.583,0,0,0-.383.219l-7,8.164a.583.583,0,1,0,.875.747l7-8.164a.583.583,0,0,0-.492-.966Zm6.963,12.392,2.479,2.478-2.679,2.679-2.479-2.478A14.647,14.647,0,0,0,49.49,995.993Z",
    transform: "translate(-14.001 -964.362)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality22);
export default __webpack_public_path__ + "static/media/speciality22.b06e71316c706328f86deb43f896ce57.svg";
export { ForwardRef as ReactComponent };